import { useSEO } from "../lib/seo";
import { LegalPage, Section, Mail } from "../components/site/LegalPage";

export default function Privacy() {
  useSEO({
    title: "Privacy Policy — Fetcher",
    description:
      "How Fetcher collects, uses and protects your data: contact details, location, Razorpay payments, retention periods and your rights.",
    path: "/privacy-policy",
  });

  return (
    <div data-testid="privacy-page">
      <LegalPage eyebrow="Legal" title="Privacy Policy" updated="June 2026">
        <Section title="Overview">
          <p>
            Fetcher (“we”, “us”, “our”) is a hyperlocal delivery marketplace operating in India. This policy explains
            what personal information we collect, why we collect it, and how you can control it. By using the Fetcher
            app or website you agree to the practices described here.
          </p>
        </Section>

        <Section title="Information we collect">
          <p>To operate the service, we collect:</p>
          <ul className="list-disc space-y-2 pl-6">
            <li><strong>Name</strong> — so riders and shops can identify your order.</li>
            <li><strong>Phone number</strong> — for order updates, OTP handover and support calls.</li>
            <li><strong>Email address</strong> — for receipts, account recovery and important notices.</li>
            <li><strong>Delivery location</strong> — to match you with a nearby rider and guide them to your door.</li>
          </ul>
        </Section>

        <Section title="Location access">
          <p>
            We request access to your device location to find nearby shops and riders and to enable live tracking. We
            use location only while you are placing or tracking an order.
          </p>
          <p>
            <strong>How to revoke:</strong> You can turn off location access at any time from your device settings
            (Android: Settings → Apps → Fetcher → Permissions → Location). The app will continue to work, but you may
            need to enter your delivery address manually.
          </p>
        </Section>

        <Section title="Payments (Razorpay)">
          <p>
            Payments are processed by our payment partner, Razorpay. When you pay by UPI, card or wallet, your payment
            details are handled directly by Razorpay under their PCI-DSS compliant systems.
          </p>
          <p>
            <strong>We do not store your card number, UPI PIN or CVV.</strong> We retain only the minimum transaction
            reference needed for receipts, refunds and dispute resolution.
          </p>
        </Section>

        <Section title="Data retention">
          <ul className="list-disc space-y-2 pl-6">
            <li><strong>Order history:</strong> retained for 24 months for support and dispute resolution.</li>
            <li><strong>Wallet &amp; payout records:</strong> retained for 7 years to meet financial and legal obligations.</li>
          </ul>
          <p>After these periods, personal data is deleted or anonymised.</p>
        </Section>

        <Section title="Your rights">
          <p>You may request to <strong>access</strong>, <strong>correct</strong> or <strong>delete</strong> your personal data at any time by emailing <Mail />. We will respond within a reasonable time as required by applicable Indian law.</p>
        </Section>

        <Section title="Governing law">
          <p>This Privacy Policy is governed by the laws of India. For any privacy questions or requests, contact us at <Mail />.</p>
        </Section>
      </LegalPage>
    </div>
  );
}
